module.exports = __webpack_public_path__ + "static/media/WTT.97e20619.png";